import React, { Component } from 'react';
import './index.scss';

// 新手指南数据
const beginnerGuide = [
    { id: 1, title: '注册/登录账号', color: '#FF5A5A' },
    { id: 2, title: '绑定学校（项目）', color: '#FF9A3C' },
];

// 常见问题数据
const faqList = [
    {
        id: 1, category: '账号', question: '新手机号登录后变成新账号了，以前的余额呢？',
        answer: `<p>● 未注册过的号一登录，往往会自动注册成新账号，旧号资产不在新号上。</p><p>● 怎么办：尽量用原号登录；必须换号时，在用户端自助修改手机号。若已形成两个账号且有余额，可联系项目负责人进行余额转存。</p><p>● 预防：换号登录前先将旧手机号修改为当前要用的手机号，如果当前号已经注册，无法修改，可以先注销新的手机号账户，再修改旧账号为新的手机号。</p>`
    },
    {
        id: 2, category: '账号', question: '我一直一键/快捷登录，没设密码，换手机后怎么办？',
        answer: `<p>怎么办：</p><p>❶ 若还能用原手机号验证，登录后尽快设密码或修改为新手机号，并确认手机号正确；</p><p>❷ SIM 卡已换且登不进原账号时，联系项目负责人将旧账号金额转入新账号或修改手机号（修改手机号部分项目不支持，以实际情况为准）。</p><p>预防：登录成功后尽快设密码；换机前确认原号仍能登录。</p>`
    },
    {
        id: 3, category: '账号', question: '如何修改手机号？',
        answer: `<p>怎么办：</p><p>❶ <b>旧账号可以登录：</b>进入账号管理，设置修改手机号，按照页面提示，获取验证码修改手机号；</p><p>❷ 联系学校负责人修改手机号，部分学校不支持的情况下可以联系旧账号余额转存到新账号。</p><p class="faq-warn">注意：改完用新手机号登录一次，仔细核对学校名称以及账户信息。</p>`
    },
    {
        id: 4, category: '账号', question: '收不到验证码/登录页异常怎么办？',
        answer: `<p>怎么办：先核对号码、查看短信是否被拦截、倒计时结束后重试；网络异常，更换网络后重试。</p><p>仍失败：换个时间再试，或截图联系学校/项目负责人（各端登录方式不同，以你当前端页面为准）。</p>`
    },
    {
        id: 5, category: '账号', question: '一键登录失败（提示本机号认证失败）怎么办？',
        answer: `<p>● <b>常见原因：</b>双卡、流量卡、运营商网关不稳定、飞行模式、非大陆号段等。</p><p>● <b>怎么办：</b>改用验证码登录；或检查网络后重试。</p><p>● <b>怎么预防：</b>重要操作前确认本机号能正常上网、能收短信。</p>`
    },
    {
        id: 6, category: '绑定学校', question: '为什么必须绑定学校？不绑行不行？',
        answer: `<p>● 服务按项目隔离，不绑定就无法匹配本校设备与充值；</p><p>● 可暂不绑定，核对好你的学校后再绑定，若不绑定部分功能不可用。</p>`
    },
    {
        id: 7, category: '绑定学校', question: '学校（项目）绑定方式有哪些？',
        answer: `<p>❶ 扫设备二维码绑定（主推）；</p><p>❷ 蓝牙搜索设备绑定；</p><p>❸ 若是有卡片的用户，可以扫描卡片二维码或者输入卡片物理ID绑定；</p><p>❹ 若是有操作指引提示使用项目二维码绑定学校也可以扫描项目二维码绑定。</p><p class="faq-warn">注意：要仔细核对学校名称，不要选错，选错了会影响后续使用，需要删除项目后重新绑定，不要随意扫描其他二维码。</p>`
    },
    {
        id: 8, category: '绑定学校', question: '该扫哪个码？扫错会怎样？',
        answer: `<p>● 扫本校设备码或工作人员出示的项目绑定码。</p><p>● 勿扫不明收款码/广告码。扫错可能导致绑错项目，解决方案见下题。</p>`
    },
    {
        id: 9, category: '绑定学校', question: '绑错学校/项目怎么办？',
        answer: `<p>● 前往我的，进入个人中心；</p><p>● 删除当前学校，会退出登录；</p><p>● 重新登录后，扫描设备二维码，绑定正确学校。</p><p class="faq-warn">注意：请仔细核对学校名称。</p>`
    },
    {
        id: 10, category: '绑定学校', question: '设备上没有二维码怎么办？',
        answer: `<p>● 换个设备重新扫码（仅本校设备，请勿随意扫描其他二维码)；</p><p>● 查看设备旁的操作指引，若操作指引提示使用项目二维码，也可扫描项目二维码绑定;</p><p>● 尝试蓝牙搜索设备进行绑定；</p><p>● 已发卡可尝试卡物理ID绑定。</p>`
    },
    {
        id: 11, category: '绑定学校', question: '扫码无反应 / 码无效？',
        answer: `<p>检查对焦、光线、二维码是否过期，换设备码或换绑定方式；仍不行把报错截图给项目负责人。</p>`
    },
    {
        id: 12, category: '绑定学校', question: '点了「暂不绑定」以后还能绑吗？',
        answer: `<p>可暂不绑定，核对好你的学校后再绑定，若不绑定部分功能不可用。</p>`
    },
    {
        id: 13, category: '其他', question: '怎样少踩坑？（清单）',
        answer: `<p>❶ 登录后记得设密码；</p><p>❷ 换号前记得修改手机号，别拿新号直接注册登录；</p><p>❸ 绑定前看清学校名，只扫官方提供的码；</p><p>❹ 有疑问保留截图问学校、联系客服或者发送邮件至 yangjun@klcxkj.com。</p>`
    },
];

const tabs = ['全部', '账号', '绑定学校', '其他'];



class HelpCenter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: '全部',
            activeKeys: [],
            arrowDown: require('../../assets/arrow.png'),
            arrowUp: require('../../assets/arrow-up.png'),
        };
    }

    componentDidMount() {
        document.title = '帮助中心';
    }

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
    };

    toggleExpand = (id) => {
        const { activeKeys } = this.state;
        const idx = activeKeys.indexOf(id);
        if (idx > -1) {
            this.setState({ activeKeys: activeKeys.filter(k => k !== id) });
        } else {
            this.setState({ activeKeys: [...activeKeys, id] });
        }
    };

    getFilteredFaq = () => {
        const { activeTab } = this.state;
        if (activeTab === '全部') return faqList;
        return faqList.filter(item => item.category === activeTab);
    };

    renderBeginnerGuide() {
        return (
            <div className="beginner-section">
                <div className="section-title">
                    <span className="title-dot"></span>
                    <span className="title-text">新手指南</span>
                </div>
                <div className="beginner-list">
                    {beginnerGuide.map(item => (
                        <div
                            className="beginner-item"
                            key={item.id}
                            onClick={() => this.props.history.push('/beginnerGuide')}
                        >
                            <span className="beginner-badge" style={{ backgroundColor: item.color }}>
                                {item.id}
                            </span>
                            <span className="beginner-title">{item.title}</span>
                            <span className="beginner-arrow">›</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderFaqSection() {
        const { activeTab, activeKeys, arrowDown, arrowUp } = this.state;
        const filteredFaq = this.getFilteredFaq();

        return (
            <div className="faq-section">
                <div className="section-title">
                    <span className="title-dot"></span>
                    <span className="title-text">常见问题</span>
                </div>
                {/* Tab 筛选 */}
                <div className="faq-tabs">
                    {tabs.map(tab => (
                        <span
                            key={tab}
                            className={`faq-tab ${activeTab === tab ? 'active' : ''}`}
                            onClick={() => this.handleTabChange(tab)}
                        >
                            {tab}
                        </span>
                    ))}
                </div>
                {/* FAQ 列表 */}
                <div className="faq-list">
                    {filteredFaq.map(item => {
                        const isExpanded = activeKeys.includes(item.id);
                        return (
                            <div className="faq-item" key={item.id}>
                                <div
                                    className="faq-question"
                                    onClick={() => this.toggleExpand(item.id)}
                                >
                                    <span className="faq-badge">{item.id}</span>
                                    <span className="faq-question-text">{item.question}</span>
                                    <img className="faq-arrow" src={isExpanded ? arrowUp : arrowDown} alt="" />
                                </div>
                                {isExpanded && item.answer && (
                                    <div className="faq-answer" dangerouslySetInnerHTML={{ __html: item.answer }} />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderFooter() {
        return (
            <div className="help-footer">
                <div className="footer-tip">仍无法解决？</div>
                <div className="footer-contact">
                    请联系学校、项目负责人<br />
                    或者发送邮件至：yangjun@klcxkj.com
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="help-center-container">
                <div className="help-content">
                    {this.renderBeginnerGuide()}
                    {this.renderFaqSection()}
                    {this.renderFooter()}
                </div>
            </div>
        );
    }
}

export default HelpCenter;
